import React from 'react'
import classNames from 'classnames'
import { Icon } from '@st-operations/uikit/src/v2'

import './styles.scss'

const FieldValidationMessage = ({ className, fieldName }) => {
  return (
    <div className={classNames('field-validation-message', className)}>
      <Icon type="fill" icon="error" className="field-validation-message__icon" />
      <span className="field-validation-message__desc">{fieldName} is required</span>
    </div>
  )
}

export default FieldValidationMessage
